<template>
  <section class="small-12 medium-12 large-6 columns">
    <h1 v-html="vueModel.ContentViewModel.Step3Accident.StepTitle" />

    <article v-if="stepModel.ProductSpecific.BodyDamageList">
      <h2 v-html="vueModel.ContentViewModel.Step3Accident.PersonSecondTitle" />
      <Field
        v-if="vueModel.CreateClaimEntity.ProductSpecific.SelectedBodyDamagedItems"
        v-slot="{ field, meta }"
        v-model="vueModel.CreateClaimEntity.ProductSpecific.SelectedBodyDamagedItems"
        name="body-area"
        :rules="{
          required: vueModel.CreateClaimEntity.ProductSpecific.SelectedBodyDamagedItems.length < 1
        }"
      >
        <personal-accident-body-parts
          :body-damage-list="stepModel.ProductSpecific.BodyDamageList"
          :content-model="vueModel.ContentViewModel.Step3Accident"
          :model-value="field.value"
          @update:model-value="field.onChange"
        />
        <ValidationError
          :name="field.name"
          :overrides="{
            required: vueModel.ContentViewModel.Step3Accident.PersonRequiredErrorMessage
          }"
          :errors="errors"
          v-show="meta.validated && !meta.valid"
        />
      </Field>
    </article>

    <article v-if="stepModel.ProductSpecific.TeethDamageList">
      <h2 v-html="vueModel.ContentViewModel.Step3Accident.TeethSecondTitle" />
      <Field
        v-if="vueModel.CreateClaimEntity.ProductSpecific.SelectedTeethDamagedItems"
        v-slot="{ field, meta }"
        v-model="vueModel.CreateClaimEntity.ProductSpecific.SelectedTeethDamagedItems"
        name="teeth-area"
        :rules="{
          required: vueModel.CreateClaimEntity.ProductSpecific.SelectedTeethDamagedItems.length < 1
        }"
      >
        <personal-accident-teeth
          :teeth-damage-list="stepModel.ProductSpecific.TeethDamageList"
          :content-model="vueModel.ContentViewModel.Step3Accident"
          :model-value="field.value"
          @update:model-value="field.onChange"
        />
        <ValidationError
          :name="field.name"
          :overrides="{
            required: vueModel.ContentViewModel.Step3Accident.TeethRequiredErrorMessage
          }"
          :errors="errors"
          v-show="meta.validated && !meta.valid"
        />
      </Field>
    </article>
  </section>
</template>

<script>
import PersonalAccidentBodyParts from '../../components/PersonalAccidentBodyPartsNew/PersonalAccidentBodyParts.vue';
import PersonalAccidentTeeth from '../../components/PersonalAccidentTeeth/PersonalAccidentTeeth.vue';
import ValidationError from '@/components/UI/ValidationError.vue';
import ReportClaimMixin from '@/components/Feature/Claims/flows/ReportClaimMixin.vue';
import ReportClaimServicesMixin from '@/components/Feature/Claims/flows/ReportClaimServicesMixin.vue';

export default {
  name: 'ReportClaimAccidentStep3',
  components: { PersonalAccidentBodyParts, PersonalAccidentTeeth, ValidationError },
  mixins: [ReportClaimMixin, ReportClaimServicesMixin],
  props: {
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    errors: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      stepModel: this.vueModel.CreateClaimStep3Model
    };
  },
  mounted() {
    if (this.vueModel.CreateClaimEntity.ProductSpecific.SelectedBodyDamagedItems === null) {
      this.vueModel.CreateClaimEntity.ProductSpecific.SelectedBodyDamagedItems = [];
    }

    if (this.vueModel.CreateClaimEntity.ProductSpecific.SelectedTeethDamagedItems === null) {
      this.vueModel.CreateClaimEntity.ProductSpecific.SelectedTeethDamagedItems = [];
    }
  }
};
</script>
